import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { useSelector } from 'react-redux'

import { Translation, useSafetyTranslation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button/Button'
import { TReportRtmType } from 'partner360/models/report/TReportRtmType'

import { COCKPIT_DOCUMENT_LINKS } from '../../../../configs/documentLinks'
import {
  selectCockpitOffering,
  selectCockpitPlanningPeriod,
  selectCockpitRtm,
  selectEffectiveCockpitFYear,
} from '../../../../model/selectors'

import styles from './CockpitDocumentLinks.module.scss'

interface ICockpitDocumentLinksProps {
  partnerId?: string
  partnerRtm?: PartnerType | null
}

export const CockpitDocumentLinks = ({ partnerId, partnerRtm }: ICockpitDocumentLinksProps) => {
  const t = useSafetyTranslation()
  const offering = useSelector(selectCockpitOffering)
  const fYear = useSelector(selectEffectiveCockpitFYear)
  const planningPeriod = useSelector(selectCockpitPlanningPeriod)
  const selectedRtm = useSelector(selectCockpitRtm)
  const isDistributor =
    partnerRtm === undefined
      ? selectedRtm === 'distributors'
      : partnerRtm === PartnerType.Distributor
  const rtm: TReportRtmType = isDistributor ? 'Distributor' : 'Reseller'

  const context = {
    partnerId,
    offering,
    fYear,
    fQuarter: planningPeriod?.fQuarter ?? 1,
    rtm,
  }

  return (
    <div className={styles.root}>
      {COCKPIT_DOCUMENT_LINKS.map(({ id, label, buildHref }) => {
        const href = buildHref(context)

        return href ? (
          <Button
            key={id}
            className={styles.link}
            variant="text"
            icon="kbase kbase-link"
            href={href}
            target="_blank"
            title={t(label)}
          >
            <span className={styles.label}>
              <Translation span text={label} />
            </span>
          </Button>
        ) : null
      })}
    </div>
  )
}

CockpitDocumentLinks.displayName = 'CockpitDocumentLinks'
